/* DCG v2-9-1 · 10 OCT 2026 · D-SP-13 S1; the bar is not measured while it is slim (D-SP-29) */
/* =========================================================
   DCG HEADER — ROW 1
   File: assets/dcg-header.js
   Version: 1.3 — 04 OCT 2026

   Handles:
   1. --dcg-mobile-bar-h measurement
   2. Condense-on-scroll (desktop) — adds .is-condensed to .dcg-header

   ── v1.3 — phone search overlay removed (D-SP-13 S1) ──────────────────
   Up to v1.2 this file also opened and closed the phone search overlay
   (#dcgSearchOverlay) and held its scroll lock. The overlay's markup left
   sections/header-top.liquid when StorePass's search bar took its place
   (SP2), so that code stopped at `if (!overlay) return` on every page.
   It is gone, with assets/dcg-search-overlay.js. Sections 1 and 2 are
   unchanged.
   ========================================================= */

(() => {
  'use strict';

  (window.DCG = window.DCG || {}).headerVersion = '1.3';

  /* -------------------------------------------------------
     REFS
     ------------------------------------------------------- */
  const header    = document.querySelector('.dcg-header');
  const mobileBar = document.querySelector('.dcg-mobile-bar');
  const root      = document.documentElement;

  /* -------------------------------------------------------
     1. MOBILE BAR HEIGHT
     Measures the bar and writes --dcg-mobile-bar-h so the
     page-container padding and whatever is placed below the bar
     are always correct.
     ------------------------------------------------------- */
  function measureMobileBar() {
    if (!mobileBar) return;
    // v2-9-1: below 768px the bar shrinks to one row while the customer scrolls down
    // (assets/dcg-phone.js). The space kept for it is its whole height, so it is not measured slim.
    if (root.classList.contains('dcg-hdr-slim')) return;
    // Only measure when bar is actually rendered (mobile viewport)
    const visible = window.getComputedStyle(mobileBar).display !== 'none';
    if (!visible) return;
    const h = Math.ceil(mobileBar.getBoundingClientRect().height);
    root.style.setProperty('--dcg-mobile-bar-h', `${h}px`);
  }

  // Run once and on resize
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', measureMobileBar);
  } else {
    measureMobileBar();
  }
  window.addEventListener('resize', measureMobileBar);
  window.DCG.measureMobileBar = measureMobileBar;      // dcg-phone.js asks for a measure after it has made the bar whole again


  /* -------------------------------------------------------
     2. CONDENSE ON SCROLL (desktop)
     Adds/removes .is-condensed on .dcg-header.
     Threshold: 100px of scroll.
     ------------------------------------------------------- */
  const CONDENSE_AT = 100;

  function updateCondense() {
    if (!header) return;
    header.classList.toggle('is-condensed', window.scrollY > CONDENSE_AT);
  }

  let scrollTicking = false;

  function onScroll() {
    if (scrollTicking) return;
    scrollTicking = true;
    requestAnimationFrame(() => {
      updateCondense();
      scrollTicking = false;
    });
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  updateCondense(); // initial state

})();
